import React from 'react'
import type { Ref } from 'react'
import PushlyIcon from '@pushly/aqe/lib/components/icons/pushly-icon'
import './pushly-loading-screen.scss'

export type PushlyLoadingScreenProps = {
    /** Shown at full opacity with the shimmer. When false the screen is transparent. */
    active: boolean
    /** `app` covers the viewport; `module` is a translucent overlay scoped to its positioned parent. */
    variant: 'app' | 'module'
    /** Fades the screen out with a CSS transition. Takes effect only on a screen that was active. */
    fadingOut?: boolean
    /** Gives a wrapper access to the screen's element. */
    containerRef?: Ref<HTMLDivElement>
}

/**
 * The Pushly loading screen. It takes props only, so it can render before any store, service or
 * theme exists: the styles carry a fallback for every theme variable. The text is for assistive
 * technology, which cannot read an animated icon; the icon itself is decorative.
 */
export const PushlyLoadingScreen = ({ active, variant, fadingOut = false, containerRef }: PushlyLoadingScreenProps) => (
    <div
        ref={containerRef}
        className={`module-loading-screen${active ? ' active' : ''}${
            fadingOut ? ' fading-out' : ''
        } variant-${variant}`}
    >
        <div className="module-loading-content">
            <span className="module-loading-icon" aria-hidden="true">
                <PushlyIcon aria-hidden="true" />
            </span>
            <span className="module-loading-text">Loading</span>
        </div>
    </div>
)
